const PANIC_TABLE = [
	{
		min: 1,
		max: 6,
		id: 'keep_it_together',
		stressDelta: 0,
		propagation: null,
	},
	{
		min: 7,
		max: 7,
		id: 'nervous_twitch',
		stressDelta: 1,
		propagation: 'short_allies_stress_plus_one',
	},
	{
		min: 8,
		max: 8,
		id: 'tremble',
		stressDelta: 0,
		propagation: null,
	},
	{
		min: 9,
		max: 9,
		id: 'drop_item',
		stressDelta: 1,
		propagation: null,
	},
	{
		min: 10,
		max: 10,
		id: 'paralysis',
		stressDelta: 1,
		propagation: 'short_allies_stress_plus_one',
	},
	{
		min: 11,
		max: 11,
		id: 'take_cover',
		stressDelta: -1,
		propagation: 'short_allies_stress_plus_one',
	},
	{
		min: 12,
		max: 12,
		id: 'scream',
		stressDelta: -1,
		propagation: 'allies_who_hear_roll_panic',
	},
	{
		min: 13,
		max: 13,
		id: 'flee',
		stressDelta: -1,
		propagation: 'allies_who_see_roll_panic',
	},
	{
		min: 14,
		max: 14,
		id: 'berserk',
		stressDelta: 0,
		propagation: 'witnesses_roll_panic',
	},
	{
		min: 15,
		max: Number.POSITIVE_INFINITY,
		id: 'catatonia',
		stressDelta: 0,
		propagation: null,
	},
];

const PANIC_TEXT = {
	en: {
		keep_it_together: {
			title: 'KEEPING IT TOGETHER',
			description: 'You keep your nerve. Barely.',
		},
		nervous_twitch: {
			title: 'NERVOUS TWITCH',
			description:
				'Increase your STRESS LEVEL by 1, and increase the STRESS LEVEL of all friendly PCs at SHORT range by 1.',
		},
		tremble: {
			title: 'TREMBLE',
			description:
				'You start to tremble uncontrollably. You suffer -2 to all skill rolls using AGILITY until your panic stops.',
		},
		drop_item: {
			title: 'DROP ITEM',
			description:
				'Stress, confusion, or the certainty that everyone is about to die makes you drop a weapon or other important item, at the GM’s choice. Increase your STRESS LEVEL by 1.',
		},
		paralysis: {
			title: 'FREEZE',
			description:
				'Fear locks you in place for one round, costing you your next slow action. Increase your STRESS LEVEL by 1, and increase the STRESS LEVEL of all friendly PCs at SHORT range by 1.',
		},
		take_cover: {
			title: 'SEEK COVER',
			description:
				'You must spend your next action trying to get away from danger and find a safe place to hide. If you have an enemy at ENGAGED range, you may make a retreat roll. Your STRESS LEVEL decreases by 1, but all friendly PCs at SHORT range increase their STRESS LEVEL by 1. After one round, you act normally again.',
		},
		scream: {
			title: 'SCREAM',
			description:
				'You scream at the top of your lungs for one round, losing your next slow action. Your STRESS LEVEL decreases by 1, but all friendly characters who hear you must immediately make a Panic Roll.',
		},
		flee: {
			title: 'FLEE',
			description:
				'You can’t take it anymore. You must flee to a safe place and refuse to leave it. You will not attack anyone or do anything dangerous. If an enemy is at ENGAGED range, you cannot make a retreat roll. Your STRESS LEVEL decreases by 1, but all friendly characters who see you flee must immediately make a Panic Roll.',
		},
		berserk: {
			title: 'BERSERK',
			description:
				'You must immediately attack the nearest person or creature, whether friend or foe. You will not stop until you or your target are broken. Any friendly character who witnesses your frenzy must immediately make a Panic Roll.',
		},
		catatonia: {
			title: 'CATATONIC',
			description:
				'You collapse to the floor, unable to talk or move, staring blankly into space.',
		},
	},
	es: {
		keep_it_together: {
			title: 'TODO CONTROLADO',
			description: 'Logras mantener la sangre fría. A duras penas.',
		},
		nervous_twitch: {
			title: 'TIC NERVIOSO',
			description:
				'Aumenta en 1 tu NIVEL DE TENSIÓN, así como el NIVEL DE TENSIÓN de todos los PJ aliados que tengas a CORTO alcance.',
		},
		tremble: {
			title: 'TEMBLEQUE',
			description:
				'Empiezas a temblar de manera descontrolada. -2 a todas las tiradas de habilidad que hagas usando la AGILIDAD hasta que cese el ataque de pánico.',
		},
		drop_item: {
			title: 'MANOS DE TRAPO',
			description:
				'Quizá sea por el estrés, la confusión o la certeza de que todos vais a morir; el caso es que dejas caer un arma u objeto importante (a elección de la DM). Tu NIVEL DE TENSIÓN aumenta en 1.',
		},
		paralysis: {
			title: 'PARÁLISIS',
			description:
				'El miedo o la angustia te paralizan durante 1 asalto, privándote de tu próxima acción lenta. Aumenta en 1 tu NIVEL DE TENSIÓN, así como el NIVEL DE TENSIÓN de todos los PJ aliados que tengas a CORTO alcance.',
		},
		take_cover: {
			title: 'A CUBIERTO',
			description:
				'Deberás usar tu próxima acción en la medida de lo posible para apartarte del peligro y buscar un lugar seguro donde cobijarte. Si tienes algún enemigo a alcance de INTERACCIÓN, se te permite hacer una tirada para retirarte (ver página 93). Tu NIVEL DE TENSIÓN se reduce en 1, pero el NIVEL DE TENSIÓN de todos los PJ aliados que tengas a CORTO alcance se incrementa en 1. Al cabo de 1 asalto podrás actuar con normalidad.',
		},
		scream: {
			title: 'ALARIDOS',
			description:
				'Gritas a pleno pulmón durante 1 asalto, lo cual te priva de tu próxima acción lenta. Tu NIVEL DE TENSIÓN se reduce en 1, pero todos los personajes aliados que te oigan gritar deberán hacer inmediatamente una tirada de Pánico.',
		},
		flee: {
			title: 'PIES EN POLVOROSA',
			description:
				'Ya no aguantas más. Huyes para refugiarte en un lugar seguro y te niegas a abandonarlo. No atacarás a nadie ni tampoco intentarás hacer nada que entrañe un mínimo peligro. Si tienes algún enemigo a alcance de INTERACCIÓN, no se te permite hacer una tirada para retirarte (ver página 93). Tu NIVEL DE TENSIÓN se reduce en 1, pero todos los personajes aliados que te vean huir deberán hacer inmediatamente una tirada de Pánico.',
		},
		berserk: {
			title: 'ARREBATO DE LOCURA',
			description:
				'Debes atacar inmediatamente a la persona o criatura que tengas más cerca, sea aliada o enemiga. No te detendrás hasta que tu objetivo o tú estéis incapacitados. Todo personaje aliado que presencie tu arrebato de locura deberá hacer inmediatamente una tirada de Pánico.',
		},
		catatonia: {
			title: 'CATATONÍA',
			description:
				'Te desplomas, incapaz de moverte o hablar, con la mirada perdida en el infinito.',
		},
	},
	ca: {
		keep_it_together: {
			title: 'TOT SOTA CONTROL',
			description: 'Aconsegueixes mantenir la sang freda. Per ben poc.',
		},
		nervous_twitch: {
			title: 'TIC NERVIÓS',
			description:
				'Augmenta en 1 el teu NIVELL DE TENSIÓ, així com el NIVELL DE TENSIÓ de tots els PJ aliats que tinguis a abast CURT.',
		},
		tremble: {
			title: 'TREMOLEIG',
			description:
				'Comences a tremolar de manera descontrolada. -2 a totes les tirades d’habilitat que facis fent servir l’AGILITAT fins que s’acabi l’atac de pànic.',
		},
		drop_item: {
			title: 'MANS DE DRAP',
			description:
				'Potser és per l’estrès, la confusió o la certesa que tots morireu; el cas és que deixes caure una arma o un objecte important, a elecció de la DM. El teu NIVELL DE TENSIÓ augmenta en 1.',
		},
		paralysis: {
			title: 'PARÀLISI',
			description:
				'La por o l’angoixa et paralitzen durant 1 ronda i et priven de la teva pròxima acció lenta. Augmenta en 1 el teu NIVELL DE TENSIÓ, així com el NIVELL DE TENSIÓ de tots els PJ aliats que tinguis a abast CURT.',
		},
		take_cover: {
			title: 'A COBERT',
			description:
				'Hauràs de fer servir la teva pròxima acció, en la mesura del possible, per apartar-te del perill i buscar un lloc segur on refugiar-te. Si tens algun enemic a abast d’INTERACCIÓ, pots fer una tirada per retirar-te. El teu NIVELL DE TENSIÓ es redueix en 1, però el NIVELL DE TENSIÓ de tots els PJ aliats que tinguis a abast CURT augmenta en 1. Al cap d’1 ronda podràs actuar amb normalitat.',
		},
		scream: {
			title: 'ESGARIPS',
			description:
				'Crides amb totes les teves forces durant 1 ronda, cosa que et priva de la teva pròxima acció lenta. El teu NIVELL DE TENSIÓ es redueix en 1, però tots els personatges aliats que et sentin hauran de fer immediatament una tirada de Pànic.',
		},
		flee: {
			title: 'CAMES AJUDEU-ME',
			description:
				'Ja no pots més. Fuges per refugiar-te en un lloc segur i et negues a abandonar-lo. No atacaràs ningú ni tampoc intentaràs fer res que comporti el més mínim perill. Si tens algun enemic a abast d’INTERACCIÓ, no pots fer una tirada per retirar-te. El teu NIVELL DE TENSIÓ es redueix en 1, però tots els personatges aliats que et vegin fugir hauran de fer immediatament una tirada de Pànic.',
		},
		berserk: {
			title: 'ARREBAT DE FOLLIA',
			description:
				'Has d’atacar immediatament la persona o criatura que tinguis més a prop, sigui aliada o enemiga. No t’aturaràs fins que tu o el teu objectiu quedeu incapacitats. Qualsevol personatge aliat que presenciï el teu arrebato haurà de fer immediatament una tirada de Pànic.',
		},
		catatonia: {
			title: 'CATATÒNIA',
			description:
				'Et desplomes, incapaç de moure’t o parlar, amb la mirada perduda en el buit.',
		},
	},
};

const normalizeLocale = (locale = 'ca') => String(locale).toLowerCase().split('-')[0];

export const getAlienPanicText = (panicEffectId, locale = 'ca') => {
	const fallbackTexts = PANIC_TEXT.es;
	return fallbackTexts[panicEffectId] || null;
};

export const getAlienPanicEntryById = (panicEffectId) =>
	PANIC_TABLE.find((entry) => entry.id === panicEffectId) || null;

export const getAlienPanicEntry = (panicResult) =>
	PANIC_TABLE.find((entry) => panicResult >= entry.min && panicResult <= entry.max) || PANIC_TABLE[0];

export default PANIC_TABLE;
